import logoSrc from '@/assets/clicks-strategic-ecosystems-logo-trimmed.png';
import styles from './CompanyLogo.module.css';

interface Props {
  className?: string;
  height?: number;
}

export function CompanyLogo({ className = '', height = 42 }: Props) {
  const width = Math.round(height * (652 / 241));
  return (
    <img
      src={logoSrc}
      alt="Clicks Strategic Ecosystems"
      className={`${styles.logo} ${className}`.trim()}
      height={height}
      width={width}
      loading="lazy"
      decoding="async"
    />
  );
}
